<template>
  <nna-container :spacing=10>
    Profilo
  </nna-container>
</template>

<script>
export default {
  name: 'Profile',
  components: {  
  },
  data() {
    return {
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/modules/profile/pages/Profile.vue